import { render, staticRenderFns } from "./QuotationHeader.vue?vue&type=template&id=0fff7974&scoped=true&"
import script from "./QuotationHeader.vue?vue&type=script&lang=js&"
export * from "./QuotationHeader.vue?vue&type=script&lang=js&"
import style0 from "./QuotationHeader.vue?vue&type=style&index=0&id=0fff7974&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fff7974",
  null
  
)

export default component.exports